<template>
  <div>
    <vs-row class="mt-5 mb-10 justify-center">
      <div class="-mx-3 flex flex-wrap justify-center w-full">
        <div class="px-3 md:w-4/12 w-full">
          <vs-button
            :to="{ name: 'new-application' }"
            class="mb-5 w-full"
            color="primary"
            type="border"
            >Заявка</vs-button
          >
        </div>
        <div class="px-3 md:w-4/12 w-full">
          <vs-button
            :to="{ name: 'new-consierge' }"
            class="mb-5 w-full"
            color="primary"
            type="border"
            >Заявка Консьерж-сервиса</vs-button
          >
        </div>
      </div>
    </vs-row>

    <vx-card
      title="Фильтры"
      class="p-6 mb-6"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-start w-full">
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <v-select
            @input="getAllRequests(currentPagingationPage, countElements)"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество обращений"
            style="background-color: #fff"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <v-select
            @input="filterRequests"
            label="name"
            :options="requestType"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Тип заявки"
            style="background-color: #fff"
            v-model="filter.type"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <v-select
            @input="filterRequests"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Поселок"
            style="background-color: #fff"
            v-model="filter.county_type"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <v-select
            @input="filterRequests"
            label="name"
            :options="statusType"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Статус"
            style="background-color: #fff"
            v-model="filter.status"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            type="number"
            v-model.number="filter.home"
          />
        </div>
        <div class="header-filter md:w-2/12 md:px-2 w-full mb-5 cursor-pointer">
          <v-select
            @input="filterRequests"
            label="name"
            :options="hiddenStatus"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Все заявки"
            style="background-color: #fff"
            v-model="filter.is_hidden"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-5 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО жителя"
            v-model="filter.user__full_name"
          />
        </div>
        <div
          class="
            header-filter
            md:w-3/12
            md:px-2
            w-full
            mb-5
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Заявка создана от"
            v-model="filter.start_date_created"
          />
          <button
            v-if="filter.start_date_created"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.start_date_created = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>
        <div
          class="
            header-filter
            md:w-3/12
            md:px-2
            w-full
            mb-5
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Заявка создана до"
            v-model="filter.end_date_created"
          />
          <button
            v-if="filter.end_date_created"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.end_date_created = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Таблица заявок | Всего: ${totalRequests}`" class="p-6">
      <vs-table
        @selected="openElement"
        :data="requests"
        :stripe="false"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Категория </vs-th>
          <vs-th> # </vs-th>
          <vs-th> Дата заявки </vs-th>
          <vs-th> Отправитель </vs-th>
          <vs-th> Подробнее о заявке </vs-th>
          <vs-th> Статус </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :state="
              (typeof data[indextr].status !== 'undefined' &&
                data[indextr].status.id == 'new') ||
              (typeof data[indextr].new_messages !== 'undefined' &&
                data[indextr].new_messages > 0)
                ? 'primary'
                : null
            "
            class="text-lg"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <span>{{ data[indextr].key.name }}</span>
            </vs-td>

            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              {{ data[indextr].date_created }}
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].address">
                <p class="mb-2">
                  Автор:
                  <span class="text-primary">{{
                    data[indextr].full_name
                  }}</span>
                </p>
                <p>
                  Адрес:
                  <span class="text-primary">{{ data[indextr].address }}</span>
                </p>
              </template>
              <template v-else>
                <p class="mb-2">
                  Автор:
                  <span class="text-primary">{{
                    data[indextr].user.full_name
                  }}</span>
                </p>
                <p
                  v-for="(address, index) in data[indextr].user.homes"
                  :key="index"
                  class="mb-2"
                >
                  Адрес:
                  <span class="text-primary">{{
                    address.county_type.name
                  }}</span
                  >, участок #
                  <span class="text-primary">{{
                    address.homestead_number
                  }}</span
                  >, ул. <span class="text-primary">{{ address.address }}</span>
                </p>
              </template>
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].key.id == 'application'">
                <p class="mb-2">
                  Тема:
                  <span class="text-primary">{{ data[indextr].theme }}</span>
                </p>
                <p class="mb-2">
                  Сообщение:
                  <span class="text-primary">{{ data[indextr].body }}</span>
                </p>
              </template>
              <template v-else-if="data[indextr].key.id == 'consierge_service'">
                <p
                  v-for="(service, index) in data[indextr].services"
                  :key="index"
                  class="mb-2"
                >
                  <span class="text-primary">{{ service.name }}</span>
                </p>
              </template>
              <template v-else-if="data[indextr].key.id == 'event_order'">
                <p class="mb-3">
                  Категория:
                  <span class="text-primary">{{
                    data[indextr].event.category.name
                  }}</span>
                </p>
                <p class="mb-3">
                  Название:
                  <span class="text-primary">{{
                    data[indextr].event.name
                  }}</span>
                </p>
              </template>

              <template
                v-if="
                  data[indextr].key.id == 'application' ||
                  data[indextr].key.id == 'consierge_service'
                "
              >
                <template v-if="data[indextr].new_messages > 0">
                  <vs-chip color="primary">
                    {{ data[indextr].new_messages }}
                  </vs-chip>
                  <span class="font-semibold">новых сообщений</span>
                </template>
                <template v-else> Новых сообщений нет </template>

                <p v-if="data[indextr].last_message_status" class="mt-2">
                  Статус сообщения:
                  {{
                    data[indextr].last_message_status == "read"
                      ? "Прочитано"
                      : "Не прочитано"
                  }}
                </p>
              </template>
            </vs-td>

            <vs-td>
              <template
                v-if="
                  data[indextr].key.id == 'application' ||
                  data[indextr].key.id == 'consierge_service'
                "
              >
                <vs-chip
                  v-if="data[indextr].status.id == 'new'"
                  color="primary"
                  class="text-lg"
                >
                  {{ data[indextr].status.name }}
                </vs-chip>

                <template v-else-if="data[indextr].status.id == 'cancelled'">
                  <span class="text-danger">{{
                    data[indextr].status.name
                  }}</span>
                </template>
                <template v-else-if="data[indextr].status.id == 'manager'">
                  <span class="text-warning">{{
                    data[indextr].status.name
                  }}</span>
                </template>
                <template v-else>
                  <span class="text-primary">{{
                    data[indextr].status.name
                  }}</span>
                </template>
              </template>
              <template v-else-if="data[indextr].key.id == 'event_order'">
                <template v-if="data[indextr].is_paid">
                  <span class="text-success">Оплачен</span>
                </template>
                <template v-else>
                  <span class="text-danger">Не оплачен</span>
                </template>
                <br />
                <template v-if="!data[indextr].is_cancelled">
                  <span class="text-success">Бронь не отменена</span>
                </template>
                <template v-else>
                  <span class="text-danger">Бронь отменена</span>
                </template>
              </template>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
import {
  API_URL,
  statusType,
  requestType,
  countyType,
  countItemsOmPage,
} from "@/.env";

import { DateTime } from "luxon";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

export default {
  data: () => ({
    requests: [],

    countElements: 20,

    currentPagingationPage: 1,
    totalRequests: 0,
    totalPagePagination: 1,
    countItemsOmPage: countItemsOmPage,

    filter: {
      type: "",
      county_type: "",
      home: "",
      status: "",
      is_hidden: false,
      user__full_name: "",
      start_date_created: null,
      end_date_created: null,
    },
    hiddenStatus: [
      { id: "true", name: "Скрытые заявки" },
      { id: "false", name: "Не скрытые заявки" },
    ],

    countyType,
    statusType,
    BASE_URL: API_URL,
    requestType: requestType,
    activeCreatePrompt: false,

    configdateTimePickerFilter: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
    },
  }),
  components: {
    DateTime,
    flatPickr,
  },
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
    },
    currentPagingationPage: function () {
      this.changePaginationPage(this.currentPagingationPage);
    },
    filter: {
      handler(val) {
        this.filterRequests();
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    filterRequests: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getAllRequests();
    }, 500),
    getAllRequests(page, limit) {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      let payload = _.clone(this.filter, true);

      if (payload.end_date_payed) {
        payload.end_date_payed = DateTime.fromFormat(
          payload.end_date_payed,
          "dd.MM.yyyy"
        ).toISODate();
      }

      if (payload.start_date_created) {
        payload.start_date_created = DateTime.fromFormat(
          payload.start_date_created,
          "dd.MM.yyyy"
        ).toISODate();
      }

      if (payload.end_date_created) {
        payload.end_date_created = DateTime.fromFormat(
          payload.end_date_created,
          "dd.MM.yyyy"
        ).toISODate();
      }

      this.$load(async () => {
        let res = (await this.$api.requests.getAllRequests(payload)).data;

        this.totalRequests = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalRequests / this.countElements
        );
        res.results.forEach((request) => {
          request.key = this.requestType.find((x) => x.id == request.key);
          request.date_created = DateTime.fromISO(
            request.date_created
          ).toFormat("dd.MM.yyyy");

          request.user.homes.forEach((home) => {
            home.county_type = countyType.find((x) => x.id == home.county_type);
          });

          if (request.date_recommend) {
            request.date_recommend = DateTime.fromISO(
              request.date_recommend
            ).toFormat("dd.MM.yyyy HH:mm");
          }

          if (request.status) {
            request.status = statusType.find((x) => x.id == request.status);
          }

          if (request.key.id == "event_order") {
            request.event.date = DateTime.fromFormat(
              request.event.date,
              "yyyy-MM-dd"
            ).toFormat("dd.MM.yyyy");

            request.event.date_start = DateTime.fromISO(
              request.event.date_start
            ).toFormat("dd.MM.yyyy HH:mm");

            request.event.date_end = DateTime.fromISO(
              request.event.date_end
            ).toFormat("dd.MM.yyyy HH:mm");
          }
        });

        this.requests = res.results;
        this.$vs.loading.close();
      });
    },
    changePaginationPage(page) {
      this.getAllRequests(page, this.countElements);
    },
    openElement(element) {
      if (element.key.id == "application") {
        this.$router.push({ name: "application", params: { id: element.id } });
      } else if (element.key.id == "consierge_service") {
        this.$router.push({ name: "consierge", params: { id: element.id } });
      } else if (element.key.id == "event_order") {
        this.$router.push({ name: "booking", params: { id: element.id } });
      }
    },
    onChangeStartDate(selectedDates, dateStr) {
      this.filter.start_date_created = DateTime.fromFormat(
        dateStr,
        "dd.MM.yyyy"
      ).toFormat("yyyy-MM-dd");
      this.filterRequests();
    },
    onChangeEndDate(selectedDates, dateStr) {
      this.filter.end_date_created = DateTime.fromFormat(
        dateStr,
        "dd.MM.yyyy"
      ).toFormat("yyyy-MM-dd");
      this.filterRequests();
    },
  },
  created() {},
  mounted() {
    this.getAllRequests();
  },
};
</script>